import { Component, OnInit, Input, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.page.html',
  styleUrls: ['./comment.page.scss'],
})
export class CommentPage implements OnInit {
  @Input() file: any = null;

  current_user: any = null;
  comment: any = {
    reply_to: null,
    reply_to_text: null,
    comment: ''
  }
  constructor(private apiService: ApiService, public globalService: GlobalService, private modalController: ModalController) { }

  ngOnInit() {
    this.current_user = this.globalService.GetCurrentUser();
    this.Get();
  }


  //Get all the comments for a file
  async Get() {
    let data: any = await this.apiService.get(`files/comments/${this.file.guid}`);
    if (data.success) {
      if (data.data)
        this.file.comments = data.data;
      else
        this.file.comments = [];
    }

  }

  async Dismiss() {
    this.modalController.dismiss();
  }

  @ViewChild('topRowRef', { static: false }) topRowRef: ElementRef | undefined;
  @ViewChild('footerRowRef', { static: false }) footerRowRef: ElementRef | undefined;
  GetCommentsSize() {
    const el = this.topRowRef.nativeElement as HTMLElement;
    const rect = el.getBoundingClientRect();
    const footerEl = this.footerRowRef.nativeElement as HTMLElement;
    const footerRect = footerEl.getBoundingClientRect();
    let allowed_size = Math.round(rect.height) - (Math.round(footerRect.height));
    console.log("Allowed Size:", allowed_size);
    return allowed_size - 1;
  }

}
